import { Correctness } from '@showbie-socrative/socrative-utils';

import { StudentScore } from '~teacher/models/activities';

export function isCorrectToCorrectness(isCorrect: boolean): Correctness | null {
  if (isCorrect === true) {
    return Correctness.Correct;
  } else if (isCorrect === false) {
    return Correctness.Incorrect;
  } else {
    return null;
  }
}
export const calculateResponseCorrectness = (response: {
  isCorrect: boolean;
}) => isCorrectToCorrectness(response?.isCorrect);

export const calculateStudentScoreCorrectness = (studentScore: StudentScore) =>
  studentScore ? studentScore.correctness : null;

export const calculateEffectiveCorrectness = ({
  studentScore,
  response,
}: {
  studentScore: StudentScore;
  response: { isCorrect: boolean };
}) =>
  calculateStudentScoreCorrectness(studentScore) ??
  calculateResponseCorrectness(response);
